import { inject, Injectable } from '@angular/core';

import { AuthTokenService, IAuthToken } from '@resident-nx/shared';
import { KeycloakService } from './keycloak.service';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenWebService extends AuthTokenService {
  #keycloakService = inject(KeycloakService);

  public getToken(): IAuthToken {
    return { accessToken: this.#keycloakService.token };
  }
}
